var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BModal",
    {
      attrs: { active: "", "has-modal-card": "" },
      on: {
        close: function() {
          return _vm.$router.push({ name: "SecondaryUsers" })
        }
      }
    },
    [
      _c(
        "form",
        {
          staticClass: "modal-card",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.create($event)
            }
          }
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title has-text-primary" }, [
              _vm._v("\n        Nuevo usuario\n      ")
            ])
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [_c("NewSecondaryUser", { attrs: { loading: _vm.loading } })],
            1
          ),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "button",
                  attrs: { to: { name: "SecondaryUsers" } }
                },
                [_vm._v("\n        Cerrar\n      ")]
              ),
              _c(
                "button",
                { staticClass: "button is-primary", attrs: { type: "submit" } },
                [_vm._v("\n        Crear usuario\n      ")]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }